import { BoxSingleMatch, BoxGenericPosterAvatar, BoxInfoMatchText, BoxNameWrestlerOrTypeMatch } from './StyledComponentsMatchCard';
import RenderNameTypeMatchCard from './RenderNameTypeMatchCard';
import RenderBeltMatchCard from './RenderBeltMatchCard';
import RenderNamePpv from './RenderNamePpv';
import { useNavigate } from 'react-router-dom';


// Container Card Match Single
function RenderSingleMatchCard(match, keyMatch, wrestlerId) {
    //Navigazione al ppv
    const navigate = useNavigate();
    const navigateToPpv = (ppv) => {
        const ppvId = ppv.id;
        const ppvName = ppv.ppv_description.name;
        navigate(`/ppv/specific/i_${ppvId}_d_${ppvName}`);
    }

    // L opponent è quel wrestler dentro match.wrestler che ha id diverso da wrestlerId 
    const opponent = match.wrestlers.find(wrestler => wrestler.id !== wrestlerId);

    const me = match.wrestlers?.find(w => w.id === wrestlerId);
    const winState = match.is_no_contest ? 'nc' : me?.is_winner ? 'win' : 'loss';

    return (
        <BoxSingleMatch key={keyMatch} winState={winState} className='box-single-match' onClick={() => navigateToPpv(match.ppv)}>
            <BoxGenericPosterAvatar className='box-wrestler-avatar'>
                <img 
                    src={process.env.REACT_APP_STORAGE_URL + opponent.avatar_path} 
                    alt={opponent.avatar_path + "_alt"}
                    className='wrestler-avatar'
                />
            </BoxGenericPosterAvatar>

            <BoxInfoMatchText className='box-info-match-text'>
                <BoxNameWrestlerOrTypeMatch className='box-name-wrestler-or-type-match'>
                    <h2 className='name-wrestler'>vs {opponent.name}</h2>
                </BoxNameWrestlerOrTypeMatch>

                {/* Nome Type Match  */}
                {RenderNameTypeMatchCard(match)}

                {/* Belt se non null */}
                {match.belt && (
                    RenderBeltMatchCard(match)
                )}

                {/* Nome PPV  */}
                {RenderNamePpv(match, keyMatch)}
            </BoxInfoMatchText>
            
        </BoxSingleMatch>
    )
}

export default RenderSingleMatchCard;